import { ComposableMap, Geographies, Geography } from 'react-simple-maps';
import '../styles/location.scss';

const geoUrl = 'https://saral-docs-prod.s3.amazonaws.com/world.json';

export default function AudienceLocationCard({ locationData }) {
  if (!locationData || locationData.length === 0) {
    return null;
  }

  const calculateOtherPercent = () => {
    let val = (locationData.slice(10, locationData.length).reduce((a, b) => a + b.weight, 0) * 100).toFixed(2);
    return val;
  };

  const highlightedCountryCodes = locationData?.map((loc) => loc.code);

  return (
    <div className="demographics-card">
      <h2>Audience Location by Country</h2>
      {locationData && (
        <div className="location-div">
          <div className="map-container">
            <ComposableMap projection="geoMercator" projectionConfig={{ scale: 140 }} viewBox="0 0 800 460">
              <Geographies geography={geoUrl}>
                {({ geographies }) =>
                  geographies.map((geo) => {
                    const isHighlighted = highlightedCountryCodes.includes(geo.properties['countryCode']);
                    return (
                      <Geography
                        key={geo.rsmKey}
                        geography={geo}
                        fill={isHighlighted ? '#d5cdf8' : '#e2e2e2'}
                        stroke="#fff"
                        strokeWidth={1}
                      />
                    );
                  })
                }
              </Geographies>
            </ComposableMap>
          </div>

          <div className="stats-container">
            {locationData?.slice(0, 10).map((loc) => (
              <div className="location-stats" key={loc.id}>
                <p>
                  <img
                    src={`https://flagcdn.com/16x12/${loc.code.toLowerCase()}.png`}
                    width="20"
                    height="15"
                    alt={loc.name}
                  />
                  {loc.name}
                </p>
                <span>{(loc.weight * 100).toFixed(2)}%</span>
              </div>
            ))}
            {locationData?.length > 10 && (
              <div className="location-stats">
                <p>Other</p>
                <span>{calculateOtherPercent()}%</span>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
